'use client';

import * as SubframeCore from '@subframe/core';
import { FeatherFileText, FeatherSettings, FeatherUpload } from '@subframe/core';
import React from 'react';
import { Button } from '../common/Button';
import * as SubframeUtils from '../utils';

interface ActionCard2RootProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  icon?: React.ReactNode;
  title?: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  variant?: 'padrao' | 'manual';
  className?: string;
}

const ActionCard2Root = React.forwardRef<HTMLDivElement, ActionCard2RootProps>(
  function ActionCard2Root(
    {
      icon = <FeatherFileText />,
      title,
      description,
      action,
      variant = 'padrao',
      className,
      ...otherProps
    }: ActionCard2RootProps,
    ref,
  ) {
    return (
      <div
        className={SubframeUtils.twClassNames(
          'group/9c53285a flex w-full flex-col items-start gap-3 rounded-[16px] border border-solid border-neutral-200 px-5 py-5',
          className,
        )}
        ref={ref}
        {...otherProps}
      >
        <div
          className={SubframeUtils.twClassNames('hidden items-center gap-2', {
            flex: variant === 'manual',
          })}
        >
          <FeatherSettings className="text-body font-body text-brand-400" />
          <span className="text-body-bold font-body-bold text-default-font">
            Mapear Campos Manualmente
          </span>
        </div>
        <span
          className={SubframeUtils.twClassNames(
            'text-caption font-caption text-subtext-color hidden',
            { inline: variant === 'manual' },
          )}
        >
          Faça upload da sua planilha e configure o mapeamento dos campos
        </span>
        <Button
          className={SubframeUtils.twClassNames('hidden h-10 w-full flex-none', {
            flex: variant === 'manual',
          })}
          variant="brand-secondary"
          icon={<FeatherUpload />}
        >
          Selecionar Arquivo
        </Button>
        <div
          className={SubframeUtils.twClassNames('flex items-center gap-2', {
            hidden: variant === 'manual',
          })}
        >
          {icon ? (
            <SubframeCore.IconWrapper className="text-body font-body text-brand-400">
              {icon}
            </SubframeCore.IconWrapper>
          ) : null}
          {title ? (
            <span className="text-body-bold font-body-bold text-default-font">{title}</span>
          ) : null}
        </div>
        {description ? (
          <span
            className={SubframeUtils.twClassNames('text-caption font-caption text-subtext-color', {
              hidden: variant === 'manual',
            })}
          >
            {description}
          </span>
        ) : null}
        {action ? (
          <div
            className={SubframeUtils.twClassNames('flex w-full flex-col items-start gap-3', {
              hidden: variant === 'manual',
            })}
          >
            {action}
          </div>
        ) : null}
      </div>
    );
  },
);

const ActionCard2 = ActionCard2Root;
